controllers.controller('AppController', [
    '$scope', '$state', '$ionicHistory', '$ionicLoading', '$ionicTabsDelegate', '$ionicModal',
    'LocaleService', 'Storage', '$timeout', 'UserService', 'constants',
    function ($scope, $state, $ionicHistory, $ionicLoading, $ionicTabsDelegate, $ionicModal,
              LocaleService, Storage, $timeout, UserService, Const) {

        $scope.verificationRequired = Storage.get('verification') || false;
        $scope.authType = Const['authType'] ? Const['authType'] : 'newforex';
        $scope.isSocial = !!Const['socialIntegration'];

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        var stateWatch = $scope.$watch(function () {
            return $state.$current.name
        }, function () {
            $ionicTabsDelegate.showBar($state.current.data && $state.current.data.footer);
        });

        $scope.$on('$destroy', function () {
            stateWatch();
        });

        this.navigate = function (state, params) {
            return $state.go(state, params);
        };

        this.back = function () {
            $ionicHistory.goBack();
        };

    }]);
